<template lang="pug">
div
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :conteudoSemId="conteudoModalSemid"
    :isVTN="false",
    :isImagem="isImagem"
    :tituloDocumento="tituloDocumento"
  )
  validation-observer(ref='validation' tag='form')
  template(v-for="cadastro in dadosCadastros")
    el-card(shadow="hover" v-if="cadastro.data && cadastro.data.length > 0").card-collapse
      p.label {{ cadastro.label }}

      el-table.margin-bottom(
        :data="cadastro.data"
      )
        template(slot="empty", v-if="cadastro.data.length === 0") Não há anexos para serem validados.
        template(v-for="(header, indexHeader) in cadastro.headers")
          el-table-column(
            :label='cadastro.headers[indexHeader].titulo',
            :prop="cadastro.headers[indexHeader].propriedade",
            :sortable="cadastro.headers[indexHeader].ordem"
            v-if="cadastro.headers[indexHeader].acao == null"
          )
          el-table-column(
            v-if="cadastro.headers[indexHeader].tipo == 'checkbox'",
            :width='280'
          )
            template(slot-scope='scope')
              div(v-if="scope.row.documentoGeo === true").flex-end
                app-action-button(
                  icone="eye",
                  text="Visualizar",
                  fontSize="18",
                  @click="abrirPdf(scope.row)"
                )
              div(v-else).flex-space-between
                el-tooltip.btn-actions(
                  effect='dark',
                  :content='verificarTooltip(scope.row)',
                  :placement="!scope.row.tipo.showValidacao ? 'right' : 'left'"
                )
                  div(v-if="scope.row.tipo.showValidacao").flex-end
                    el-button.button(
                      v-if="visualizarDocumentosPDF",
                      :disabled="verificarExtensao(scope.row)",
                      @click="abrirDocumento(scope.row)"
                    )
                      font-awesome-icon(icon="eye", size="lg")
                  div(v-else).margin-left
                    el-button.button(
                      v-if="visualizarDocumentosPDF",
                      :disabled="verificarExtensao(scope.row)",
                      @click="abrirDocumento(scope.row)"
                    )
                      font-awesome-icon(icon="eye", size="lg")
                app-action-button(
                  icone="download",
                  @click="downloadArquivo(scope.row)",
                  cor="#666666",
                  text="Baixar Documento"
                  posicaoTooltip="left"
                  v-if="scope.row.tipo.showValidacao"
                )
                validation-provider(rules="required", v-slot="{ errors }" v-show="scope.row.tipo.showValidacao")
                  el-radio-group.input.padding(
                    @change="setValidacaoDocumento(cadastro)",
                    v-model="scope.row.isValido",
                    :class="{'erro' : errors.length}"
                  )
                    el-radio(:label="true") Válido
                    el-radio(:label="false") Inválido
</template>
<script>
import { mapActions } from 'vuex'
import AppActionButton from './AppActionButton'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'

const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppActionButton,
    AppModalVisualizaPdf
  },

  props: {
    dadosCadastros: {
      type: Array
    }
  },

  data () {
    return {
      // preencher o array com a quantidade de arquivos recebidos do componente pai
      valido: [],
      conteudoModal: '',
      tituloModal: '',
      tipoModal: '',
      conteudoModalSemid: null,
      showModalVisualizaPdf: false,
      visualizarDocumentosPDF: false,
      setorCodigo: null,
      isImagem: false
    }
  },

  async created () {
    const user = await this.getUsuario()
    this.setorCodigo = user.perfilSelecionado.codigo
    this.dadosCadastros.forEach(dadosCadastro => {
      if (dadosCadastro.tipo === 'tabelaComCheck' && dadosCadastro?.data) {
        dadosCadastro.data.forEach((data, index) => {
          const documento = data
          this.valido.push(documento)
        })
        this.$emit('setDocumentosValidar', true)
      } else {
        this.$emit('setDocumentosValidar', false)
      }
    })
    this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.perfis.includes(this.setorCodigo)
    await this.sortData()
  },

  computed: {
    dadosExiste () {
      return this.cadastro?.data?.length !== 0
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),
    setValidacaoDocumento (dadoCadastro) {
      const novoCadastro = _.cloneDeep(dadoCadastro) //eslint-disable-line
      this.$emit('setValidacaoDocumentos', novoCadastro)
    },

    downloadArquivo (arquivo) {
      this.$emit('downloadDocumentoCadastro', arquivo)
    },

    abrirPdf (arquivo) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && arquivo.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = arquivo.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${arquivo.caminho.split(diretorio)[1]}`, arquivo.tipo.descricao, 'height=500,width=800,top=250px,left=250px,right=150px')
        return
      }
      this.tituloModal = arquivo.tipo.descricao
      this.conteudoModal = arquivo.id
      this.tipoModal = 'DOCUMENTO_AUTENTICAVEL'
      this.showModalVisualizaPdf = true
    },

    abrirDocumento (arquivo) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && arquivo.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = arquivo.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${arquivo.caminho.split(diretorio)[1]}`, arquivo.tipo.descricao, 'height=500,width=800,top=250px,left=250px,right=150px')
        return
      }
      if (arquivo.id === null) {
        this.tituloModal = 'Visualizar Documento'
        this.tipoModal = 'DOCUMENTO_SEM_ID'
        this.conteudoModal = 0
        this.conteudoModalSemid = arquivo
        this.isImagem = this.abrirImagem(arquivo)
        this.showModalVisualizaPdf = true
        this.tituloDocumento = arquivo.tipo.descricao
        return
      }
      if (arquivo.tipo.codigo !== 'LAUDO_AUTOMATICO') {
        this.tituloModal = 'Visualizar Documento'
        this.tipoModal = 'DOCUMENTO'
        this.conteudoModal = arquivo.id
        this.showModalVisualizaPdf = true
        this.isImagem = this.abrirImagem(arquivo)
        this.tituloDocumento = arquivo.tipo.descricao
      } else {
        this.tipoModal = 'LAUDO_VALIDACAO'
        this.tituloModal = 'Laudo análise automatizada'
        this.showModalVisualizaPdf = true
        this.tituloDocumento = arquivo.tipo.descricao
        this.conteudoModal = Number(this.$route.params.idProcesso)
      }
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },

    verificarExtensao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      let value
      if (regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        value = false
      } else {
        value = true
      }
      return value
    },

    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      let isImagem

      if (regrasAnalise.visualizarDocumentosPDF.extensaoImagens.includes(extensao)) {
        isImagem = true
      } else {
        isImagem = false
      }
      return isImagem
    },

    verificarTooltip (row) {
      let extensao = utils.getExtensionFile(row.nome)

      if (regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        return 'Visualizar Documento'
      } else {
        return 'Não é possível exibir esse arquivo'
      }
    },
    async sortData () {
      if (this.dadosCadastros[0]) {
        this.dadosCadastros[0].data.sort((a, b) => {
          if (a.tipo.codigo === 'RELATORIO_ANALISE_GERAL' && b.tipo.codigo !== 'RELATORIO_ANALISE_GERAL') {
            return 1
          } else if (a.tipo.codigo !== 'RELATORIO_ANALISE_GERAL' && b.tipo.codigo === 'RELATORIO_ANALISE_GERAL') {
            return -1
          } else {
            return 0
          }
        })
      }
    }

  }
}
</script>
<style scoped lang="scss">
.label {
  font-weight: bold;
}
.margin-top {
  margin-top: 30px;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.margin-left {
  margin-left: 240px;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.padding {
  padding: 5px;
}

.margin-right {
  margin-right: 10px;
}

.margin-bottom {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDadosCadastro.vue